var _path, _rect, _rect2, _rect3, _rect4, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRarityCommon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7797 4.97407L17.2961 3.11688C15.8259 2.50792 14.174 2.50792 12.7039 3.11688L8.22021 4.97407C6.75005 5.58304 5.582 6.75108 4.97304 8.22125L3.11584 12.7049C2.50688 14.1751 2.50688 15.827 3.11584 17.2971L4.97304 21.7808C5.582 23.251 6.75005 24.419 8.22021 25.028L12.7039 26.8852C14.174 27.4941 15.8259 27.4941 17.2961 26.8852L21.7797 25.028C23.2499 24.419 24.418 23.251 25.0269 21.7808L26.8841 17.2971C27.4931 15.827 27.4931 14.1751 26.8841 12.7049L25.0269 8.22125C24.418 6.75108 23.2499 5.58304 21.7797 4.97407ZM18.0614 1.26912C16.1012 0.457168 13.8987 0.457168 11.9385 1.26912L7.45485 3.12632C5.49462 3.93827 3.93723 5.49566 3.12528 7.45588L1.26808 11.9396C0.456131 13.8998 0.456131 16.1023 1.26808 18.0625L3.12528 22.5462C3.93723 24.5064 5.49462 26.0638 7.45485 26.8757L11.9385 28.7329C13.8987 29.5449 16.1012 29.5449 18.0614 28.7329L22.5451 26.8757C24.5053 26.0638 26.0627 24.5064 26.8747 22.5462L28.7319 18.0625C29.5438 16.1023 29.5438 13.8998 28.7319 11.9396L26.8747 7.45588C26.0627 5.49566 24.5053 3.93827 22.5451 3.12631L18.0614 1.26912Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 2,
    width: 2,
    height: 4,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 24,
    width: 2,
    height: 4,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 2,
    width: 2,
    height: 4,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 24,
    width: 2,
    height: 4,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.656 20.999L10.88 19.223V10.983L12.656 9.20703H18.464L20.176 10.903L18.592 12.423L17.36 11.223H14.016L13.376 11.847V18.343L14.016 18.983H17.488L18.704 17.783L20.288 19.303L18.592 20.999H12.656Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarityCommon);
export default __webpack_public_path__ + "static/media/rarity-common.961343ab.svg";
export { ForwardRef as ReactComponent };